import { readonly, ref } from 'vue'

const heldUntilStatusChanges = ref<string | null>(null)

export function holdUntilStatusChanges(status: string) {
  heldUntilStatusChanges.value = status
}

export function clearCommissioningOptimisticHold() {
  heldUntilStatusChanges.value = null
}

export function useCommissioningOptimisticHold() {
  return {
    heldUntilStatusChanges: readonly(heldUntilStatusChanges),
    holdUntilStatusChanges,
    clearCommissioningOptimisticHold,
  }
}
